import * as React from 'react';
import './UserProfilePage.css';
import { useAuth } from '../../hooks/useAuth';
import Text from '../../components/Text/Text';
import ChangeEmailForm from '../../components/ChangeEmailForm/ChangeEmailForm';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';
import SupportForm from '../../components/SupportForm/SupportForm';
import { useTranslation } from 'react-i18next';
import { UserOutlined } from '@ant-design/icons';

const UserProfilePage = React.memo(() => {
  const { t } = useTranslation('translation');
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="PageShell UserProfilePage">
      <header className="PageHero">
        <div className="PageHero__glow" aria-hidden />
        <div className="PageHero__content">
          <span className="PageHero__eyebrow">
            <UserOutlined /> Fish Hunter
          </span>
          <Text size={6} bold>
            {t('profile')}
          </Text>
          <Text type="secondary" size={3}>
            Управление email, паролем и обратной связью
          </Text>
        </div>
      </header>

      <section className="SurfaceCard">
        <ChangeEmailForm user={user} />
        <ChangePasswordForm />
      </section>

      <section className="SurfaceCard">
        <SupportForm />
      </section>
    </div>
  );
});

export default UserProfilePage;
